import { render } from "./App.vue?vue&type=template&id=fee36f1a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fee36f1a&lang=css"
script.render = render

export default script